module.exports = {
      id: "default-image-usage",
      viewBox: "0 0 322 191",
      url: __webpack_public_path__ + "svg-sprite-b468923450c663eeca769f8899a6b186.svg#default-image",
      toString: function () {
        return this.url;
      }
    }